import React from 'react';
import { RadioButton } from "../RadioButton";
import { Typography } from "../Typography";
import styles from "./RadioButtonWithLabel.module.scss";
import { RadioButtonWithLabelTestIds } from "./RadioButtonWithLabel.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RadioButtonWithLabel = _ref => {
  let {
    id,
    label,
    testId,
    checked,
    sublabel,
    disabled,
    onChange
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles.root,
    "data-testid": testId,
    children: /*#__PURE__*/_jsx(RadioButton, {
      id: id,
      "data-testid": testId && RadioButtonWithLabelTestIds.RadioButton(testId),
      onChange: onChange,
      checked: checked,
      disabled: disabled,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.label,
        children: [/*#__PURE__*/_jsx(Typography, {
          children: label
        }), sublabel && /*#__PURE__*/_jsx(Typography, {
          skin: "secondary",
          children: sublabel
        })]
      })
    })
  });
};